import type { ErrorCode } from './errors';

/** Consistent success envelope (§47). */
export interface ApiSuccess<T, M = Record<string, unknown>> {
  success: true;
  data: T;
  meta: M;
}

export interface ApiErrorBody {
  code: ErrorCode | string;
  message: string;
  details?: Record<string, unknown>;
}

/** Consistent error envelope (§47). */
export interface ApiFailure {
  success: false;
  error: ApiErrorBody;
}

export type ApiResponse<T, M = Record<string, unknown>> = ApiSuccess<T, M> | ApiFailure;

/** Server-side pagination metadata (§56). */
export interface PageMeta {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  sort?: string;
}

export interface Paginated<T> {
  items: T[];
  meta: PageMeta;
}

export interface ValidationIssue {
  path: string;
  message: string;
  code?: string;
}

export const API_BASE_PATH = '/api/v1';

/** Request headers understood by the API. */
export const ApiHeaders = {
  CORRELATION_ID: 'x-correlation-id',
  CSRF_TOKEN: 'x-csrf-token',
  DEVICE_ID: 'x-device-id',
  IDEMPOTENCY_KEY: 'idempotency-key',
} as const;

/** Cookie names used by the API. */
export const ApiCookies = {
  REFRESH_TOKEN: 'fas_rt',
  CSRF_TOKEN: 'fas_csrf',
} as const;
